import { createContext, useContext } from 'react';

import {
  AccountDetails,
  SignInDetails,
  SignInMfaRequest,
  SignInRequest,
  SignUpRequest,
  UserDetails,
  UserMfaSettingsDto
} from '@/api/generated';

export type LoginContextProps = {
  isAuthenticated: boolean;
  signInLoading: boolean;
  userDetailsLoading: boolean;
  currentUser: UserDetails | null;
  currentAccount: AccountDetails | undefined;
  refetchUserDetails: () => void;
  signOut: () => void;
  signIn: (data: SignInRequest) => Promise<SignInDetails | undefined>;
  signUp: (data: SignUpRequest) => Promise<SignInDetails | undefined>;
  signUpLoading: boolean;
  mfaSignIn: (data: SignInMfaRequest) => Promise<void>;
  isLoadingAuthMfaSignin: boolean;
  userMfaSettings: UserMfaSettingsDto | undefined;
  getUserMfaSettings: () => void;
};

export const LoginContext = createContext<LoginContextProps>({
  isAuthenticated: false,
  signInLoading: false,
  userDetailsLoading: true,
  currentUser: null,
  currentAccount: undefined,
  refetchUserDetails: () => undefined,
  signOut: () => {
    // eslint-disable-next-line no-console
    console.warn('signOut method not implemented');
  },
  signIn: async () => undefined,
  signUp: async () => undefined,
  signUpLoading: false,
  mfaSignIn: async () => undefined,
  isLoadingAuthMfaSignin: false,
  userMfaSettings: undefined,
  getUserMfaSettings: () => undefined
});

const useLoginContext = () => useContext(LoginContext);

export default useLoginContext;
